import { TableClass } from '../../../world/spa/libs/classes';

export default {
	foodOrderStatus() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'waiting',
				en: "Waiting for approval",
				it: "In attesa di approvazione"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'notAccepted',
				en: "Rejected",
				it: "Rigettato"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'preparing',
				en: "Preparing",
				it: "In preparazione"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'ready',
				en: "Ready",
				it: "Pronto"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'delivering',
				en: "Delivering",
				it: "In consegna"
			},
			6: {
				typeClass: 6,
				typeClassLiteral: 'delivered',
				en: "Delivered",
				it: "Consegnato"
			}
		});
	},
	foodProductPricingType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'unit',
				it: "A pezzo",
				en: "Unit"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'weight',
				it: "A peso",
				en: "Weight"
			}
		});
	},
	foodProductStatus() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'available',
				en: "Available",
				it: "Disponibile"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'hidden',
				en: "Hidden",
				it: "Nascosto"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'unavailable',
				en: "Unavailable",
				it: "Non disponibile"
			}
		});
	},
	foodProductStockType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'unlimited',
				it: "Illimitato",
				en: "Unlimited"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'unit',
				it: "A pezzo",
				en: "Unit"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'weight',
				it: "A peso",
				en: "Weight"
			}
		});
	},
	foodPermission() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'superuser',
				en: "Superuser",
				it: "Superuser"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'owner',
				en: "Owner",
				it: "Proprietario"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'manager',
				en: "Manager",
				it: "Manager"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'maitre',
				en: "Maitre",
				it: "Direttore di sala"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'register',
				en: "Register",
				it: "Punto cassa"
			},
			6: {
				typeClass: 6,
				typeClassLiteral: 'waiter',
				en: "Waiter",
				it: "Cameriere"
			}
		});
	},
	foodUnitOfMeasurement() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'kg',
				it: "Chilogrammo",
				en: "Kilogram"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'l',
				it: "Litro",
				en: "Liter"
			}
		});
	},
	foodDeliveryOption() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'alwaysApplyCost',
				it: "Applicare sempre il costo di consegna",
				en: "Always apply the delivery cost"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'applyUnderMin',
				it: "Applicare il costo di consegna sotto l'ordine minimo",
				en: "Apply the delivery cost under the minimum order"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'disableUnderMin',
				it: "Impedire inoltro sotto l'ordine minimo",
				en: "Disable forwarding under the minimum order"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'applyAboveAndDisableUnderMin',
				it: "Applicare costo di consegna sopra e impedire inoltro sotto l'ordine minimo",
				en: "Apply delivery cost above and disable forwarding under the minimum order"
			}
		});
	},
	foodFavPages() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'ordersList',
				it: "Lista ordini in attesa",
				en: "Waiting orders list"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'tablesList',
				it: "Lista tavoli",
				en: "Tables list"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'fastCash',
				it: "Cassa rapida",
				en: "Fast cash"
			}
		});
	},
	foodLogEventType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'newOrder',
				en: "New order",
				it: "Nuovo ordine"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'editOrder',
				en: "Order edited",
				it: "Modifica ordine"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'deleteOrder',
				en: "Order deleted",
				it: "Cancellazione ordine"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'payment',
				en: "Payment",
				it: "Pagamento"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'orderDiscount',
				en: "Order discount",
				it: "Sconto ordine"
			},
			6: {
				typeClass: 6,
				typeClassLiteral: 'productDiscount',
				en: "Product discount",
				it: "Sconto prodotto"
			},
			7: {
				typeClass: 7,
				typeClassLiteral: 'deleteElement',
				en: "Element deleted",
				it: "Cancellazione elemento"
			},
			8: {
				typeClass: 8,
				typeClassLiteral: 'emitCard',
				en: "Card emitted",
				it: "Emissione tessera"
			},
			9: {
				typeClass: 9,
				typeClassLiteral: 'editCard',
				en: "Card info modified",
				it: "Modifica dati tessera"
			},
			10: {
				typeClass: 10,
				typeClassLiteral: 'topUpCard',
				en: "Card topped up",
				it: "Ricarica tessera"
			},
			11: {
				typeClass: 11,
				typeClassLiteral: 'printerError',
				en: "Sequence printer error",
				it: "Errore stampante comande"
			},
			12: {
				typeClass: 12,
				typeClassLiteral: 'printerQueueEmptied',
				en: "Sequences queue emptied",
				it: "Comande bruciate"
			}
		});
	}
}
